import axios from 'axios';
import { ERROR_MESSAGES } from './errorMessages.js';
import { DateStringMMDDYYYY } from './actions/types.mjs';
import { format } from 'date-fns';

export const isObject = (obj) => {
  if (obj === null) { return false; }
  if (typeof obj !== 'object') { return false; }
  if (Array.isArray(obj)) { return false; }
  return true;
};

export const isArray = (obj) => {
  if (obj === null) { return false; }
  if (typeof obj !== 'object') { return false; }
  return Array.isArray(obj);
};

//export const getConstructionDaysElapsed = (project) => {
//  if(!isObject(project)) { return '?'; }
//  if(typeof project.beginDate !== 'string') { return '?'; }
//
//  const oneDayInMilliseconds = 1000*60*60*24;
//  const todayAtNoon = new Date();
//  todayAtNoon.setHours(12, 0, 0, 0); // set to noon
//
//  const beginDateObject = parseDatestring(project.beginDate);
//  if(typeof beginDateObject === 'string') { return '?'; }; // parse error
//  beginDateObject.setHours(12, 0, 0, 0); // set to noon
//  return Math.max(0, parseInt((todayAtNoon.getTime() - beginDateObject.getTime()) / oneDayInMilliseconds));
//};
//

export const getProjectCompletionDatestring = (beginDatestring, projectDayCount) => {
  try {
    const beginDateObject = DateStringMMDDYYYY.toDateObject(beginDatestring);
    beginDateObject.setHours(0, 0, 0, 0); // set to beginning of day
    projectDayCount = parseInt(projectDayCount);
    if(typeof projectDayCount !== 'number' || projectDayCount < 0) throw new Error();

    const oneDayInMilliseconds = 1000 * 60 * 60 * 24;
    const endDateObject = new Date(beginDateObject.getTime() + (oneDayInMilliseconds * projectDayCount));
    endDateObject.setHours(23, 59, 59, 0); // set to end of day
    return format(endDateObject.getTime(), 'MM/dd/yyyy');
  } catch(error) {
    return '?';
  }
};

export const getProjectDaysRemaining = (beginDatestring, projectDayCount) => {
  try {
    const beginDateObject = DateStringMMDDYYYY.toDateObject(beginDatestring);
    beginDateObject.setHours(0, 0, 0, 0); // set to beginning of day
    projectDayCount = parseInt(projectDayCount);
    if(typeof projectDayCount !== 'number' || projectDayCount < 0) throw new Error();

    const oneDayInMilliseconds = 1000 * 60 * 60 * 24;
    const endDateObject = new Date(beginDateObject.getTime() + (oneDayInMilliseconds * projectDayCount));
    endDateObject.setHours(23, 59, 59, 0); // set to end of day
    const currentTimeObject = new Date();
    const result = parseInt((endDateObject.getTime() - currentTimeObject.getTime()) / oneDayInMilliseconds);
    if(isNaN(result)) throw new Error();
    return result;
  } catch(error) {
    return '?';
  }
};

export const getServerApiResponse = (postDataObject, onSuccess, onFailure) => {
  axios.post(process.env.REACT_APP_WEBSITE_ACTION_API_URL, postDataObject).then((response) => {
    try {
      if(!isObject(response)) { throw "no response"; }
      if(!isObject(response.data)) { throw 'no response data'; }
      if(!isObject(response.headers)) { throw 'no response headers'; }
      if(response.status !== 200) { throw "non 200 http response code"; }

      // Handle different response structure from lamda@edge and apigateway
      let appData = null;
      if(typeof response.headers['apigw-requestid'] === 'string') { 
        // if "apigw-requestid" attribute is defined in response.headers the response is from apigateway
        try {
          appData = JSON.parse(response.data.body);
        } catch(error) {
          throw 'error parsing response.data.body from apigateway';
        }
        if(!isObject(appData)) { throw 'no appData from apigateway'; }
      } else { 
        // assume the response is from lambda@edge
        appData = response.data;
      }

      if(appData.status === 'error' && typeof appData.data === 'string') { throw 'api error'; }
      if(!isObject(appData.data)) { throw 'no appData data'; }
      if(appData.status === 'error' && typeof appData.data.clientMessage === 'string' && appData.data.clientMessage.length > 0) {
        throw { 'modalMessage' : appData.data.clientMessage };
      }
      if(appData.status !== 'success') { throw 'non success response from server'; }

      if(typeof onSuccess === 'function') {
        onSuccess(appData.data);
      }

      // TODO: check and handle logout event here 
    } catch(error) {
      if(typeof onFailure === 'function') {
        onFailure(typeof error === 'object' && 'modalMessage' in error ? error.modalMessage : null);
      }
      //logger.addError('error doing stuff ' + error)
    }
  }).catch((error) => {
    if(typeof onFailure === 'function') {
      onFailure(ERROR_MESSAGES.NETWORK_ERROR);
    }
  });
};

export const keyIsInObject = (key, object) => {
  if(typeof key === 'undefined') return false;
  if(!isObject(object)) return false;
  if(typeof key === 'number') return (''+key) in object;
  if(typeof key === 'string') return key in object;
  return false;
};

export const keyCountInObject = (object) => {
  if(!isObject(object)) return 0;

  let numberOfKeys = 0;
  for(const key in object) {
    numberOfKeys++;
  }
  return numberOfKeys;
};

export const millisDurationToString = (millisDuration) => {
  let timeSinceLatestMessage = '';
  const secondsElapsed = millisDuration / 1000;
  const minutesElapsed = secondsElapsed / 60;
  const hoursElapsed = secondsElapsed / 3600;
  const daysElapsed = secondsElapsed / 86400;

  if(daysElapsed >= 1) {
    timeSinceLatestMessage = Math.round(daysElapsed) + " day" + (Math.round(daysElapsed) !== 1 ? 's' : '');
  } else if(hoursElapsed >= 1) {
    timeSinceLatestMessage = Math.round(hoursElapsed) + " hour" + (Math.round(hoursElapsed) !== 1 ? 's' : '');
  } else if(minutesElapsed >= 1) {
    timeSinceLatestMessage = Math.round(minutesElapsed) + " minute" + (Math.round(minutesElapsed) !== 1 ? 's' : '');
  } else {
    timeSinceLatestMessage = parseInt(secondsElapsed) + " second" + (parseInt(secondsElapsed) !== 1 ? 's' : '');
  }

  return timeSinceLatestMessage;
};

export const objectKeysToList = (object) => {
  if(!isObject(object)) return [];

  const keys = [];
  for(const key in object) {
    keys.push(key);
  }
  return keys;
};

export const objectValuesToList = (object) => {
  if(!isObject(object)) return [];

  const values = [];
  for(const key in object) {
    values.push(object[key]);
  }
  return values;
};

export function getJsonFromUrl(query) {
  var result = {};
  query.split("&").forEach(function(part) {
    if(!part) return;
    part = part.replaceAll("+", " ");
    var eq = part.indexOf("=");
    var key = eq>-1 ? part.substring(0,eq) : part;
    var val = eq>-1 ? decodeURIComponent(part.substring(eq+1)) : "";
    var from = key.indexOf("[");
    if(from===-1) result[decodeURIComponent(key)] = val;
    else {
      var to = key.indexOf("]",from);
      var index = decodeURIComponent(key.substring(from+1,to));
      key = decodeURIComponent(key.substring(0,from));
      if(!result[key]) result[key] = [];
      if(!index) result[key].push(val);
      else result[key][index] = val;
    }
  });
  return result;
}

export const getShorthandElapsedSinceTimestamp = (timestamp) => {
  let timeSinceLatestMessage = '';
  const millisecondsElapsed = new Date().getTime() - timestamp;
  const secondsElapsed = millisecondsElapsed / 1000;
  const minutesElapsed = secondsElapsed / 60;
  const hoursElapsed = secondsElapsed / 3600;
  const daysElapsed = secondsElapsed / 86400;

  if(daysElapsed >= 1) {
    timeSinceLatestMessage = Math.round(daysElapsed) + "d";
  } else if(hoursElapsed >= 1) {
    timeSinceLatestMessage = Math.round(hoursElapsed) + "h";
  } else if(minutesElapsed >= 1) {
    timeSinceLatestMessage = Math.round(minutesElapsed) + "m";
  } else {
    timeSinceLatestMessage = parseInt(secondsElapsed) + "s";
  }

  return timeSinceLatestMessage;
};

export const debugLog = process.env.REACT_APP_LIVE_MODE === 'false' ? console.log : function() {};

export const uuidv4 = () => {
  if (crypto.randomUUID) {
    return crypto.randomUUID();
  }

  const bytes = crypto.getRandomValues(new Uint8Array(16));

  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;

  const hex = [...bytes].map(b => b.toString(16).padStart(2, "0")).join("");

  return (
    hex.slice(0, 8) + "-" +
    hex.slice(8, 12) + "-" +
    hex.slice(12, 16) + "-" +
    hex.slice(16, 20) + "-" +
    hex.slice(20)
  );
}

export const copyToClipboard = (text) => {
  if (navigator.clipboard && window.isSecureContext) {
    return navigator.clipboard.writeText(text);
  } else {
    // iOS fallback
    const textArea = document.createElement("textarea");
    textArea.value = text;
    
    // Prevent scrolling
    textArea.style.position = "fixed";
    textArea.style.opacity = "0";
    
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      document.execCommand("copy");
    } catch (err) {
      debugLog("Copy failed", err);
    }

    document.body.removeChild(textArea);
  }
};
